
interface SelectCounterProps {
  value: number;
}

export default function SelectCounter({ value }: SelectCounterProps) {
  return <div className="select-counter">{value}</div>;
}
